import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import PropTypes from "prop-types";

import { useRef } from "react";
import { useFieldsForm } from "../../../hooks/useFieldsForm";
import listFields from "../../../../../ui/utils/fields";
import { pascalCase } from "pascal-case";

export const FieldsForm = () => {
    const fieldsFormRef = useRef(null);

    const {signers, currentSigner, setSigner, handleClickField} = useFieldsForm(fieldsFormRef);
    
    return (
        <div 
            className="form-fields">
            <p className="md-text grey-text">
                1. Selecciona el firmante al que agregar campos
            </p>
            <FormControl fullWidth style={{margin: "32px 0"}}>
                <InputLabel>Firmante</InputLabel>

                <Select
                    value={currentSigner}
                    label="Firmantes"
                    onChange={({target})=>setSigner(target.value)}>
                    { Object.keys(signers).map((signerId) => (
                        <MenuItem key={signerId} value={signers[signerId]}>
                            { signers[signerId].email }
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <p className="md-text mh-1 grey-text">
                2. Arrastra y suelta elementos para agregar campos
            </p>
            <br />
            <div 
                ref={fieldsFormRef}
                className="form-fields__fields">
                    {
                        listFields.map((field, index) => {
                            return (
                                <Field
                                    key={index}
                                    field={field}
                                    signer={currentSigner}
                                    handleClickField = {handleClickField}
                                />
                            );
                        })
                    }
            </div>
        </div>
    );
};

const Field = ({ field, signer, handleClickField }) => {
    return (
        <>
            <div 
                className="fields__item-form"
                onClick={(event) => handleClickField(event, field, signer)}>
                    {field.icon}
                    <p className="sm-text gray-text">{{ 'sign': 'Firma', 'date': 'Fecha', 'text': 'Texto' }[field.type] ?? pascalCase(field.type)}</p>
            </div>
        </>
    );
};

Field.propTypes = {
    field: PropTypes.object.isRequired,
    signer: PropTypes.string.isRequired,
    handleClickField: PropTypes.func.isRequired
};

